import { render, staticRenderFns } from "./StockUpLimitReason.vue?vue&type=template&id=2f194182"
import script from "./StockUpLimitReason.vue?vue&type=script&lang=js"
export * from "./StockUpLimitReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports